var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCartOffers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_21956",
    "data-name": "Group 21956",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.564,
    height: 24,
    viewBox: "0 0 24.564 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_39947",
    "data-name": "Path 39947",
    d: "M24.564,12c0,.895-1.256,1.637-1.447,2.474-.2.865.608,2.077.232,2.857s-1.836.916-2.379,1.6-.346,2.128-1.03,2.675-2.043.028-2.836.411-1.224,1.765-2.089,1.962c-.837.19-1.838-.865-2.733-.865s-1.9,1.055-2.733.865c-.865-.2-1.309-1.586-2.089-1.962S5.3,22.146,4.623,21.6s-.483-1.99-1.03-2.675-2-.8-2.379-1.6.429-1.991.232-2.856C1.256,13.636,0,12.894,0,12s1.256-1.637,1.447-2.474c.2-.865-.608-2.077-.232-2.857s1.836-.916,2.379-1.6S3.94,2.943,4.624,2.4s2.043-.028,2.836-.411S8.684.219,9.549.022c.837-.19,1.838.865,2.733.865s1.9-1.055,2.733-.865c.865.2,1.309,1.586,2.089,1.962s2.155-.132,2.837.412.483,1.99,1.03,2.675,2,.8,2.379,1.6-.429,1.991-.232,2.856c.19.837,1.446,1.579,1.446,2.474",
    transform: "translate(0 0.001)",
    fill: "#f46d6a"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "percent",
    transform: "translate(6.4 6.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_534",
    "data-name": "Line 534",
    d: "M0,8.6a.6.6,0,0,1-.424-.176.6.6,0,0,1,0-.849l8-8a.6.6,0,0,1,.849,0,.6.6,0,0,1,0,.849l-8,8A.6.6,0,0,1,0,8.6Z",
    transform: "translate(1.6 1.6)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_1467",
    "data-name": "Ellipse 1467",
    d: "M2-.6A2.6,2.6,0,1,1-.6,2,2.6,2.6,0,0,1,2-.6Zm0,4A1.4,1.4,0,1,0,.6,2,1.4,1.4,0,0,0,2,3.4Z",
    transform: "translate(0.6 0.6)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_1468",
    "data-name": "Ellipse 1468",
    d: "M2-.6A2.6,2.6,0,1,1-.6,2,2.6,2.6,0,0,1,2-.6Zm0,4A1.4,1.4,0,1,0,.6,2,1.4,1.4,0,0,0,2,3.4Z",
    transform: "translate(6.6 6.6)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartOffers);
export default __webpack_public_path__ + "static/media/cart_offers.5b49b3c727199e90be06bedc220fa9e3.svg";
export { ForwardRef as ReactComponent };